/**
 * UI Library Style Imports
 * 统一导入所有 UI 库的样式，解决动态加载时样式丢失的问题
 */

// Vant 样式 - 使用 CSS 而非 Less 以避免编译问题
import 'vant/lib/index.css'

// Muse UI 基础样式
import 'muse-ui/lib/styles/base.less'

// Muse UI 核心组件样式
import 'muse-ui/lib/styles/components/appbar.less'
import 'muse-ui/lib/styles/components/select.less'
import 'muse-ui/lib/styles/components/text-field.less'
import 'muse-ui/lib/styles/components/dialog.less'
import 'muse-ui/lib/styles/components/progress.less'
import 'muse-ui/lib/styles/components/expansion-panel.less'
import 'muse-ui/lib/styles/components/data-table.less'

// Muse UI 内部依赖样式
import 'muse-ui/lib/styles/components/input.less' // TextField 和 Select 的基础依赖
import 'muse-ui/lib/styles/components/overlay.less' // Dialog 和 Select (via Popover) 的依赖
import 'muse-ui/lib/styles/components/button.less' // Dialog 的依赖
import 'muse-ui/lib/styles/components/popover.less' // Select 的依赖
import 'muse-ui/lib/styles/components/list.less' // Select 的依赖
import 'muse-ui/lib/styles/components/checkbox.less' // Select 和 DataTable 的依赖
import 'muse-ui/lib/styles/components/chip.less' // Select 的依赖
import 'muse-ui/lib/styles/components/elevation.less' // AppBar 的依赖
import 'muse-ui/lib/styles/components/expand-transition.less' // ExpansionPanel 的依赖

// Icon 组件的样式包含在 base.less 中，不需要单独导入

// Muse UI Loading 样式
import 'muse-ui-loading/dist/muse-ui-loading.css'

// Element UI 样式
import 'element-ui/lib/theme-chalk/index.css'

console.log('UI library styles imported')
